import React from 'react';
import { Gallery } from '../components/Gallery';
import { Countdown } from '../components/Countdown';

export const GalleryPage = () => {
  return (
    <div className="min-h-screen bg-black pt-24">
      <div className="container mx-auto px-4 lg:px-8 py-8">
        <Countdown />
      </div>
      <Gallery />
    </div>
  );
};